import React, { useState } from 'react';
import { withTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import { UserService } from '../../services/UserService';
import useRequest from '../../hooks/useRequest';

import MainLayout from '../../components/Layouts/MainLayout';

import ChangePassword from 'components/atoms/ChangePassword';


import './styles.scss';

const ChangePasswordView = () => {
    const history = useHistory();

    const {
        afterSubmit, errors, 
        dealWithError
    } = useRequest();

    const handleSubmit = (data) => {

        UserService.update(data)
            .then(data => {
                afterSubmit();
                history.push('/confirmar_password');
            }).catch((error) => {
                dealWithError(error, 'Error al cambiar la contraseña');
            });
    }

    return (
        <MainLayout>
            <ChangePassword handleSubmit={handleSubmit} error={errors}></ChangePassword>
        </MainLayout>
    );
}

export default withTranslation()(ChangePasswordView);